import type { ComponentType, SVGProps } from 'react'

import { cn } from 'lib/utils'

import { iconMap } from './iconMap'
import type { IconName } from './iconMap'

import './index.scss'

const mainClass = 'icon'

interface IconProps {
  name: IconName
  className?: string
  width?: number
  height?: number
  isColor?: boolean
}

const getIconComponent = (
  name: IconName
): ComponentType<SVGProps<SVGSVGElement>> => {
  return iconMap[name]
}

export const Icon = ({
  name,
  className = '',
  width,
  height,
  isColor = false,
}: IconProps) => {
  const IconComponent = getIconComponent(name)

  return (
    <span
      className={cn(mainClass, className, {
        [`${mainClass}--color`]: isColor,
      })}
      aria-hidden="true"
    >
      <IconComponent width={width} height={height} />
    </span>
  )
}
